import {initTooltips} from "../../core/js/Tooltip.ts";
import {$get} from "../../core/js/Ajax.ts";
import {$, html_chargement_en_cours} from "../../core/js/Dom.ts";
import {fadeIn, fadeOut} from "../../core/js/Animate.ts";
import {updateMenuInfos} from "../../core/js/Onglets.ts";
import {refreshAlerts} from "../../portail/js/DossierAlerts.ts";


export const initCarto = () => {
    window.vuejsAppBaseUrl = location.origin
    window.printUrl = window.Openscop.carto_printUrl
    window.historiqueUrl = window.Openscop.carto_historiqueUrl
    window.manifPk = window.Openscop.manifPk
    window.editorSettings = window.Openscop.editorSettings
    window.user = window.Openscop.editorUser
    window.isOrganisateur = window.Openscop.isOrganisateur
    window.isInstructeur = window.Openscop.isInstructeur
    window.isInInstruction = window.Openscop.isInInstruction
    window.showLabelAModifierNouveauParcours = window.Openscop.showLabelAModifierNouveauParcours
    window.showAjouterParcoursBtn = window.Openscop.showAjouterParcoursBtn

    Promise.all([
        // @ts-ignore
        import('../static/carto/css/carto.css'),
        // @ts-ignore
        import('../static/carto/css/pois.css'),
        // @ts-ignore
        import('../static/carto/css/picto-vtm-img.css'),
        // @ts-ignore
        import('../static/carto/js/NavigatorDetector.js'),
        // @ts-ignore
        import('../static/carto/cartoVue/app.js'),
        // @ts-ignore
        import('../static/carto/cartoVue/app.css')
    ]).finally(() => {
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('showApp'))
            setTimeout(() => {
                initTooltips()
            }, 1000)
        }, 2000)
    }).catch((error) => {
        if(window.Openscop.debug) {
            console.error('carto error : ', error)
            console.error('carto error message : ', error.message)
        }
    })
}

export function updateAlerteCarto() {
    const container = $('#carto-alertes')
    if(container) {
        if(container.innerHTML == "") container.appendChild(html_chargement_en_cours())
        $get(window.Openscop.url_get_carto_alertes).then((response) => {
            if(container.innerHTML != response.body) {
                fadeOut(container).then(() => {
                    container.innerHTML = response.body
                    fadeIn(container)
                })
            }
        })
    }

    requestAnimationFrame(updateMenuInfos)
    requestAnimationFrame(refreshAlerts)
}

window.Openscop.updateAlerteCarto = updateAlerteCarto

